const PencilIcon = ({ viewBox = "0 0 24 24", className = "hayley-h-6 hayley-w-6 hayley-text-custom-10" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path d="M13.7651 7.5957L16.9597 10.7903" stroke="currentColor" strokeMiterlimit="10" />
      <path
        d="M9.72218 18.028L5.88867 18.6669L6.52759 14.8334L15.098 6.26293C15.3377 6.02337 15.6626 5.88879 16.0015 5.88879C16.3403 5.88879 16.6653 6.02337 16.9049 6.26293L18.2926 7.65066C18.5322 7.89029 18.6668 8.21525 18.6668 8.55409C18.6668 8.89292 18.5322 9.21789 18.2926 9.45752L9.72218 18.028Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default PencilIcon;
